import { jsxs as m, jsx as s } from "react/jsx-runtime";
import { memo as F } from "react";
import { Stack as u, FormControl as x, InputLabel as b } from "@mui/material";
import { OverLabel as f } from "./styles31.mjs";
const q = F(
  ({
    labelType: e = "inside",
    fullWidth: i,
    label: d,
    info: c,
    isOptional: a,
    id: n,
    name: h,
    ...r
  }) => {
    const t = e === "outside" ? d : void 0, l = e === "inside" ? d : void 0, o = n || h;
    return /* @__PURE__ */ m(u, { display: "inline-flex", sx: { width: i ? "100%" : "auto" }, children: [
      t && /* @__PURE__ */ s(
        f,
        {
          $disabled: !!r.disabled,
          htmlFor: o,
          id: o,
          info: c,
          isOptional: a,
          required: r.required,
          error: r.error,
          children: t
        }
      ),
      /* @__PURE__ */ m(x, { ...r, fullWidth: i, children: [
        l && /* @__PURE__ */ s(b, { htmlFor: o, id: o, children: l }),
        r.children
      ] })
    ] });
  }
);
export {
  q as FormControl
};
//# sourceMappingURL=index49.mjs.map
